import React, { useEffect, useState } from "react";
import { Dialog, Box, Typography, Button, Stack } from "@mui/material";
import CakeIcon from "@mui/icons-material/Cake";
import WorkIcon from "@mui/icons-material/Work";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useAuth } from "../../context/AuthContext";

// Matches the color/icon scheme already used for these occasions on the Dashboard
const OCCASION_META = {
  birthday: {
    icon: CakeIcon,
    color: "#F57C00",
    gradient: "linear-gradient(135deg, #FF9800, #F57C00)",
    title: "Happy Birthday",
    message: (years) =>
      years > 0 ? `Wishing you an amazing ${years}${ordinal(years)} birthday!` : "Wishing you a fantastic day!",
  },
  work_anniversary: {
    icon: WorkIcon,
    color: "#1565C0",
    gradient: "linear-gradient(135deg, #42A5F5, #1565C0)",
    title: "Work Anniversary",
    message: (years) => `Congratulations on ${years} year${years === 1 ? "" : "s"} with the team!`,
  },
  wedding_anniversary: {
    icon: FavoriteIcon,
    color: "#C62828",
    gradient: "linear-gradient(135deg, #EF5350, #C62828)",
    title: "Happy Anniversary",
    message: (years) =>
      years > 0 ? `Wishing you and your partner a joyful ${years}${ordinal(years)} anniversary!` : "Wishing you a joyful anniversary!",
  },
};

function ordinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
}

export default function WelcomeWishModal() {
  const { user } = useAuth();
  const [wishes, setWishes] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const raw = sessionStorage.getItem("loginWishes");
    if (!raw) return;
    sessionStorage.removeItem("loginWishes");
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        setWishes(parsed);
        setOpen(true);
      }
    } catch {
      // ignore malformed data
    }
  }, []);

  if (wishes.length === 0) return null;

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 4, overflow: "hidden" } }}
    >
      <Box sx={{ p: 4, textAlign: "center" }}>
        <Stack spacing={3}>
          {wishes.map((w, idx) => {
            const meta = OCCASION_META[w.type];
            if (!meta) return null;
            const Icon = meta.icon;
            return (
              <Box key={idx}>
                <Box
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: meta.gradient,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 2,
                    boxShadow: `0 8px 24px ${meta.color}55`,
                  }}
                >
                  <Icon sx={{ fontSize: 34, color: "#fff" }} />
                </Box>
                <Typography variant="h5" sx={{ fontWeight: 800, color: meta.color }}>
                  {meta.title}, {user?.name?.split(" ")[0]}! 🎉
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                  {meta.message(w.years)}
                </Typography>
              </Box>
            );
          })}
        </Stack>

        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          sx={{ mt: 4, borderRadius: 2, px: 4, py: 1 }}
        >
          Thank You!
        </Button>
      </Box>
    </Dialog>
  );
}